export const roundPriceToThousands = (price: number): number => {
    return Math.round(price / 1000) * 1000;
};
export const roundPriceToThousands = (price: number): number => {
    return Math.round(price / 1000) * 1000;
};
